module.exports = __webpack_public_path__ + "static/media/4_Standing up on the inside_IN.22491388.txt";